<template>
    <div class="menu-container">
        <div class="mobile-menu-button">
            <i v-if="!mobile_menu_open"
               class="material-icons notranslate"
               @click="open_menu"
            >menu</i>
            <i v-else
               class="material-icons notranslate"
               @click="close_menu"
            >close</i>
        </div>
        <nav :class="{
            'dashboard-menu': true,
            'mobile_menu_open': mobile_menu_open
        }">
            <ul @click="close_menu">
                <MenuLink :text="$t('profiles')"
                          :tooltip="$t('profiles_tooltip')"
                          :memberOnly="false"
                          icon="assignment_ind"
                          link="/profiles"
                />
                <MenuLink :text="$t('Account')"
                          :tooltip="$t('Account_tooltip')"
                          :memberOnly="false"
                          icon="assignment"
                          link="/my-account"
                />
                <MenuLink :text="$t('Team')"
                          :tooltip="$t('team_tooltip')"
                          :memberOnly="false"
                          icon="group"
                          link="/about"
                />
                <MenuLink :text="$t('awards')"
                          :tooltip="$t('awards_tooltip')"
                          :memberOnly="true"
                          icon="star"
                          link="/awards"
                />
                <MenuLink :text="$t('awards_results')"
                          :tooltip="$t('awards_results_tooltip')"
                          :memberOnly="false"
                          icon="rate_review"
                          link="/awards_results"
                />
                <MenuLink :text="$t('reviews')"
                          :tooltip="$t('reviews_tooltip')"
                          :memberOnly="false"
                          icon="image_search"
                          link="/reviews"
                />
                <MenuLink :text="$t('disputes')"
                          :tooltip="$t('disputes_tooltip')"
                          :memberOnly="false"
                          icon="report"
                          link="/disputes"
                />
                <MenuLink :text="$t('Stamps')"
                          :tooltip="$t('stamps_tooltip')"
                          :memberOnly="true"
                          icon="verified"
                          link="/stamps"
                />
                <MenuLink :text="$t('partners')"
                          :tooltip="$t('partners_tooltip')"
                          :memberOnly="true"
                          icon="loyalty"
                          link="/partners"
                />
            </ul>
        </nav>
        <div :class="{
            'black_cover': true,
            'active': mobile_menu_open
        }" @click="close_menu"></div>
    </div>
</template>

<script>
import MenuLink from './MenuLink'
export default {
  name: 'Menu',
  components: { MenuLink },
  data () {
    return {
      mobile_menu_open: false
    }
  },
  computed: {
  },
  methods: {
    open_menu: function () {
      this.mobile_menu_open = true
    },
    close_menu: function () {
      this.mobile_menu_open = false
    }
  }
}
</script>

<style lang="scss">
    .menu-container {
        align-self: flex-start;
        @media only screen and (min-width: 1260px) {
          position: sticky;
          z-index: 45;
          top: 65px;
        }
        @media only screen and (max-width: 1259px) {
          width: 0;
        }
    }
    .dashboard-menu {
        width: 120px;
        background: #fff;
        ul {
            list-style: none;
            margin: 0;
            padding: 0;
            li {
                padding: 8px 12px;
                display: block;
            }
        }
    }
    @media only screen and (max-width: 1259px) {
        %transition {
            transition:
                opacity 0.3s cubic-bezier(0.4, 0.0, 0.2, 1),
                transform 0.3s cubic-bezier(0.4, 0.0, 0.2, 1);
        }
        %animate_visibility_off {
            visibility: hidden;
            opacity: 0;
            transition: visibility 0s linear 0.2s,opacity 0.2s linear;
        }
        %animate_visibility_on {
            visibility: visible;
            opacity: 1;
            transition-delay: 0s;
        }
        .mobile-menu-button {
            position: fixed;
            top: 8px;
            left: 24px;
            z-index: 60;
            i {
                font-size: 36px;
                padding: 6px;
                cursor: pointer;
                color: #000;
                opacity: 0.54;
                &:hover {
                    opacity: 0.87;
                }
            }
        }
        .dashboard-menu {
            z-index: 45;
            min-height: calc(100vh - 65px);
            @extend %transition;
            transform: translateX(-144px);
            @media only screen and (max-width: 1259px) {
              position: relative;
            }
            .menu-link::after {
                @extend %transition;
                @extend %animate_visibility_off;
            }
        }
        .dashboard-menu.mobile_menu_open {
            transform: translateX(0);
            .menu-link::after {
                @extend %animate_visibility_on;
            }
        }
        .black_cover {
            position: fixed;
            top: 65px;
            right: 0;
            bottom: 0;
            left: 0;
            background: rgba(0,0,0,0.84);
            z-index: 40;
            @extend %transition;
            @extend %animate_visibility_off;
        }
        .black_cover.active {
            @extend %animate_visibility_on;
        }
    }
    @media only screen and (min-width: 1260px) {
        .mobile-menu-button {
            display: none;
        }
        .dashboard-menu {
            z-index: 60;
        }
        .black_cover {
            display: none;
        }
    }

</style>

<i18n>
    {
        "en": {
            "home": "Home",
            "home_tooltip": "Checkout a overview of your profiles and also quick access to useful links",
            "profiles": "Profiles",
            "profiles_tooltip": "Manage all information, data and media that are present in your profiles",
            "Account": "Account",
            "Account_tooltip": "Keep up to date all information about your Inspiration account",
            "awards": "Awards",
            "awards_tooltip": "Check out the next awards, read the rules of the awards and do not forget the most important: Participate!",
            "awards_results": "Results",
            "awards_results_tooltip": "Check out the results and analysis of your participation in the Inspiration Awards.",
            "payments": "Payments",
            "payments_tooltip": "Check the financial situation of each of your profiles is and also check your detailed payment history",
            "partners": "Partners",
            "partners_tooltip": "For being an Inspiration member, you have access to special promotions and discounts from our partners, check out your benefits here",
            "Stamps": "Stamps",
            "stamps_tooltip": "Download the Inspiration member stamps and place them on your website and social networks",
            "Team": "Team",
            "team_tooltip": "Get to know our team and contact us to leave a question, suggestion, compliment or criticism.",
            "reviews": "Reviews",
            "reviews_tooltip": "You can read the reviews you requested here",
            "disputes_tooltip": "You can read the disputes you requested here"
        },
        "pt": {
            "home": "Início",
            "home_tooltip": "Tenha uma visão geral sobre seus perfis e também acesso rápido a links úteis",
            "profiles": "Perfis",
            "profiles_tooltip": "Gerencie todas informações, dados e mídias que estão presentes em seus perfis.",
            "Account": "Cadastro",
            "Account_tooltip": "Mantenha todas as informações atualizadas sobre sua conta do Inspiration",
            "awards": "Envio Awards",
            "awards_tooltip": "Confira quando acontece o próximo awards, leia o regulamento da premiação e não se esqueça do mais importante: Participe!",
            "awards_results": "Resultados Awards",
            "awards_results_tooltip": "Confira o resultado e avaliações de suas participações no Inspiration Awards.",
            "payments": "Pagamentos",
            "payments_tooltip": "Verifique como está a situação financeira de cada um dos seus perfis e também confira seu histórico de pagamentos detalhado",
            "Stamps": "Selos",
            "stamps_tooltip": "Faça o download dos selos de membro Inspiration e coloque em seu site e redes sociais",
            "partners": "Parceiros",
            "partners_tooltip": "Por sem membro Inspiration você tem acesso a promoções e ofertas especiais de nossos parceiros, confira aqui seus benefícios!",
            "Team": "Equipe",
            "team_tooltip": "Conheça nossa equipe e entre em contato conosco para deixar uma dúvida, sugestão, elogio ou crítica.",
            "reviews": "Análises",
            "reviews_tooltip": "Você pode ler as análises críticas que você solicitou aqui",
            "disputes_tooltip": "Você pode ler as contestações que você iniciou aqui"
        }
    }
</i18n>